import { render, staticRenderFns } from "./IntegrationScreensListItem.vue?vue&type=template&id=31505130&"
import script from "./IntegrationScreensListItem.vue?vue&type=script&lang=js&"
export * from "./IntegrationScreensListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports